<template>
    <div class="container-principal">               
        <div class="form">
            <div class="titulo-filtros-cabecalho tamanho-fonte"> Sistema em Manutenção! </div>

            <span class="titulo-filtros-cabecalho">
                <img
              class="img-manutencao"
              src="@/assets/imgs/Manutencao.svg"
            />
            </span>


            <g-button
              class="buscar-button-header-filtro"
              largura="200px"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="this.$router.push('/')"
            >
              Voltar para o Login
            </g-button>
        </div>
    </div>
</template>

<script>
import Tapume from './Tapume.js'
export default Tapume
</script>

<style scoped>

.tamanho-fonte{
    font-size: 30px;
}

.carregar{
    font-size: 77px;
    padding: 15px;
}


.container-principal {
height: 100%;
width: 100%;
display: flex;
align-items: center;
justify-content: center;
background-image: url(@/assets/imgs/fundo_retangulos.svg);
background-size: 100%;
background-position: center;
}


.form {
display: flex;
flex-direction: column;
gap: 20px;
justify-content: center;
align-items: center;
grid-area: form;
}


@media (min-width:461px) {
.container-principal{
    background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
    url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

        background-size: 100%;
background-position: center;

}

.img-manutencao{
    width: 200px;
}

}

@media (min-width:600px) {
    .container-principal{
    background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
    url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

        background-size: 100%;
background-position: center;

}

.img-manutencao{
    width: 300px;
}

}

@media (min-width:1025px) {
.tamanho-fonte{
    font-size: 50px;
}
.img-manutencao{
    width: 400px;
}
.container-principal{
    background: url(@/assets/imgs/Fundo_login_1.svg) no-repeat top left,
    url(@/assets/imgs/Fundo_login_2.svg) no-repeat bottom right;

        background-size: 100%;
background-position: center;

}
}

@media (min-width:1500px) {
.container-login {
height: 100%;
min-height: 380px;
align-items: center;
margin-top: 46px;
gap: 5px;
display: grid;
grid-template-columns: 1fr;
grid-template-rows: 38% 23% 39%;
grid-auto-flow: row;
grid-template-areas:
    "logo"
    "form"
    "botoes";
}

}
</style>